module.exports = __webpack_public_path__ + "images/yellow-on.png";